var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandingColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10593_29060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.625 12.75C12.6605 12.75 13.5 11.9105 13.5 10.875C13.5 9.83947 12.6605 9 11.625 9C10.5895 9 9.75 9.83947 9.75 10.875C9.75 11.9105 10.5895 12.75 11.625 12.75Z",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.125C19.5 17.25 21.375 15.75 21.375 15.75C21.375 15.75 23.25 17.25 23.25 19.125C23.25 19.6223 23.0525 20.0992 22.7008 20.4508C22.3492 20.8025 21.8723 21 21.375 21C20.8777 21 20.4008 20.8025 20.0492 20.4508C19.6975 20.0992 19.5 19.6223 19.5 19.125Z",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11.5763L12.016 20.5603C11.8767 20.6996 11.7113 20.8102 11.5293 20.8856C11.3473 20.961 11.1522 20.9998 10.9552 20.9998C10.7582 20.9998 10.5631 20.961 10.3811 20.8856C10.1991 20.8102 10.0337 20.6996 9.89439 20.5603L1.93971 12.6056C1.80038 12.4663 1.68986 12.301 1.61446 12.1189C1.53905 11.9369 1.50024 11.7419 1.50024 11.5448C1.50024 11.3478 1.53905 11.1528 1.61446 10.9707C1.68986 10.7887 1.80038 10.6234 1.93971 10.4841L10.9238 1.5L21 11.5763Z",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2994 9.54938L3.74908 3",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10593_29060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingColor);
export default __webpack_public_path__ + "static/media/branding_color.4c4ad727772d8bf87b755cb04b7bce1b.svg";
export { ForwardRef as ReactComponent };